module.exports = "\r\n<nav class=\"leftsettingbox\">\r\n        <ul class=\"list-unstyled settinglist\">   \r\n           <li><a [routerLink]=\"['entity']\" hasPermission=\"admin.entity.entity.active\"  routerLinkActive=\"selected\"  title=\"Entity Details\"><section>  &nbsp; &nbsp; Entity Management</section></a></li>              \r\n        </ul>     \r\n</nav> \r\n<router-outlet></router-outlet>  "


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/entity/ent.component.html
// module id = ./src/app/admin/entity/ent.component.html
// module chunks = main